/*
The original file is in the back ups folder
*/

import { 
	setAppPage
} from '../store/appStateReducers';

import { useEffect } from "react";

import { useDispatch } from 'react-redux';


export const LoginPage = (props) => {

	const dispatch = useDispatch();

	useEffect(()=>{
		dispatch( setAppPage( 
			{
				page: "selectAppPage",
				props: {}
			})
		);
	},[dispatch]);


	return (
		<></>
	);

}
